import { rpc } from "#rpc";
import { useQuery } from "@tanstack/react-query";

export const useAlgoliaPopularSearches = () => {
	return useQuery({
		queryKey: ["algolia-popular-searches"],
		queryFn: async () => rpc.search.popularSearches(),
	});
};
